(function () {
  function isProductPage() { return !!document.querySelector('main[data-template*="product"], .product-information'); }
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
  function normalizeUrl(src) { if (!src) return ''; if (src.startsWith('//')) return window.location.protocol + src; return src; }
  function fileKey(src) { return String(normalizeUrl(src) || '').split('/').pop().split('?')[0]; }

  function setImage(img, src) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.loading = 'eager';
    img.decoding = 'async';
    img.src = normalizeUrl(src);
    img.style.display = 'block';
    img.style.opacity = '1';
    img.style.visibility = 'visible';
    img.style.objectFit = 'contain';
    img.style.objectPosition = 'center center';
    img.style.mixBlendMode = 'normal';
    img.style.transform = 'none';
  }

  function firstMobileImage() {
    return document.querySelector('.product-information .volaant-mobile-product-frame:first-child img, .volaant-mobile-product-frame:first-child img');
  }

  function frameFor(img) {
    return img.closest('.volaant-force-media-frame, .volaant-liquid-media-frame, slideshow-slide, .product-media-container, .product-media, li, [data-media-id]') || img.parentElement || img;
  }

  function visibleDesktopGalleries() {
    var selectors = [
      '.product-information__media .volaant-force-media-fallback',
      '.product-information__media .volaant-liquid-media-fallback',
      '.product-information__media media-gallery',
      '.product-information__media .media-gallery',
      '.product-information__media slideshow-component'
    ];
    var galleries = [];
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (gallery) {
        var style = window.getComputedStyle(gallery);
        if (style.display !== 'none' && style.visibility !== 'hidden') galleries.push(gallery);
      });
    });
    return galleries;
  }

  function promoteDesktopMediaWithoutScrolling(src) {
    src = normalizeUrl(src);
    var selectedKey = fileKey(src);
    if (!selectedKey) return;

    visibleDesktopGalleries().forEach(function (gallery) {
      var imgs = Array.prototype.slice.call(gallery.querySelectorAll('img'));
      var selectedImg = imgs.find(function (img) {
        return ((img.currentSrc || img.src || '').indexOf(selectedKey) !== -1);
      });
      if (!selectedImg) return;

      var selectedFrame = frameFor(selectedImg);
      if (selectedFrame && selectedFrame.parentElement === gallery && gallery.firstElementChild !== selectedFrame) {
        gallery.insertBefore(selectedFrame, gallery.firstElementChild);
      }
    });
  }

  function syncVariantMedia(src) {
    src = normalizeUrl(src);
    if (!isProductPage() || !src) return;

    if (isMobile()) {
      var img = firstMobileImage();
      if (img) setImage(img, src);
      return;
    }

    promoteDesktopMediaWithoutScrolling(src);
  }

  function mediaSrcFromVariantResource(resource) {
    return resource && resource.featured_media && resource.featured_media.preview_image && resource.featured_media.preview_image.src;
  }

  function productHandle() {
    var match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function selectedVariantSrcFromProductJson() {
    var handle = productHandle();
    if (!handle) return Promise.resolve('');
    window.__volaantProductJson = window.__volaantProductJson || {};
    if (!window.__volaantProductJson[handle]) {
      window.__volaantProductJson[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return window.__volaantProductJson[handle].then(function (product) {
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="cart"] input[name="id"], input[name="id"]');
      var id = input ? String(input.value || input.getAttribute('value') || '') : '';
      if (!product || !product.variants || !id) return '';
      var variant = product.variants.find(function (item) { return String(item.id) === id; });
      return variant && variant.featured_image ? normalizeUrl(variant.featured_image.src || variant.featured_image) : '';
    });
  }

  function syncCurrentVariant() {
    selectedVariantSrcFromProductJson().then(function (src) { if (src) syncVariantMedia(src); });
  }

  document.addEventListener('variant:update', function (event) {
    var src = mediaSrcFromVariantResource(event.detail && event.detail.resource);
    window.setTimeout(function () { if (src) syncVariantMedia(src); else syncCurrentVariant(); }, 80);
  }, true);

  document.addEventListener('click', function (event) {
    if (!isProductPage()) return;
    if (!event.target.closest('button,label,[role="button"],input,select,.variant-picker__option,.product-form__input')) return;
    window.setTimeout(syncCurrentVariant, 120);
  }, true);

  document.addEventListener('change', function (event) {
    if (!isProductPage()) return;
    if (!event.target.closest('input,select')) return;
    window.setTimeout(syncCurrentVariant, 120);
  }, true);
})();
